module.exports = __webpack_public_path__ + "static/media/locked-chest.4fef2a91.svg";